'use client';

import { createContext, useContext } from 'react';
import useDealPage from '@/creditflowresearch/application/Deal/contexts/useDealPage';
import { IDealContextProps } from '@/creditflowresearch/application/Deal/types';

type DealPageContextType = ReturnType<typeof useDealPage>;

export const DealPageContext = createContext<DealPageContextType>(null);

export const useDealPageContext = () => {
  const context = useContext(DealPageContext);
  if (!context) {
    throw new Error('useDealPageContext must be used within the DealPageContext');
  }
  return context;
};

const DealPageContextProvider = ({ children, deal }: IDealContextProps) => (
  <DealPageContext.Provider value={ useDealPage(deal) }>
    { children }
  </DealPageContext.Provider>
);
export default DealPageContextProvider;
